import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import store from "redux/store";
import { GET_CANCELCHARGES, GET_CANCELTRIP } from "resources/actionTypes";
import { cancelTripService, cancelationChargesService } from "services/Operationservice";
import { getBookingDetails, getBookingList } from "redux/actions/ReservationAction";
import { getRideDetails } from "redux/actions/UserDashboard";

const companyID = localStorage.getItem("subCompany")?.length > 0 && JSON.parse(localStorage.getItem("subCompany"));

function* cancelTrip(action) {
  const payload = action.payload || {};
  const cancelTripDetails = yield call(cancelTripService, payload?.trip);
  if (cancelTripDetails.success) {
    yield put({ type: GET_CANCELTRIP.GET_CANCELTRIP_SUCCESS });
    toast.success(cancelTripDetails.message);
    if(payload?.pageType === "bookingDetails")  {
      store.dispatch(getBookingDetails(payload?.trip?.id))
    }
    else if(payload?.tripPayload?.tab ==='dashboard'){
      store.dispatch(getBookingList({...payload?.tripPayload, companyId: companyID?.value}));
      store.dispatch(getRideDetails({...payload?.tripPayload,companyId: companyID?.value}))
    }
    else {
      store.dispatch(getBookingList({...payload?.tripPayload, companyId: companyID?.value}));
    }
  } else {
    yield put({
      type: GET_CANCELTRIP.GET_CANCELTRIP_FAILED,
      message: cancelTripDetails.message,
    });
    toast.error(cancelTripDetails.message || "Trip Cancelled Successfully");
  }
}

export function* cancelTripSaga() {
  yield takeEvery(GET_CANCELTRIP.GET_CANCELTRIP_REQUESTED, cancelTrip);
}

function* getCancelChargesListener(action) {
  
  const payload = action.payload || {};
  const cancelChargesResponse = yield call(cancelationChargesService, payload?.id);

  if (cancelChargesResponse.success) {
    yield put({type: GET_CANCELCHARGES.GET_CANCELCHARGES_SUCCESS, cancelCharges: cancelChargesResponse});
    payload?.setCancelCharges(true);
  } else {
    yield put({
      type: GET_CANCELCHARGES.GET_CANCELCHARGES_FAILED,
      message: cancelChargesResponse.message,
    });
      toast.error(cancelChargesResponse.message || "Failed to fetch Cancel Charges");
  }
}

export function* getCancelChargesWatcher() {
  yield takeEvery(GET_CANCELCHARGES.GET_CANCELCHARGES_REQUESTED, getCancelChargesListener);
}